<section class="platform-shell">
  <aside class="platform-sidebar">
    <div class="platform-brand">
      <p class="platform-brand__eyebrow">{{ brand.name }}</p>
      <h1>Platform Admin</h1>
      <p>{{ currentUserName() }}</p>
    </div>

    <nav class="platform-nav" aria-label="Super admin navigation">
      <a routerLink="/platform/dashboard" routerLinkActive="active">
        <mat-icon aria-hidden="true">dashboard</mat-icon>
        Dashboard
      </a>
      <a routerLink="/platform/organizations" routerLinkActive="active">
        <mat-icon aria-hidden="true">apartment</mat-icon>
        Manage Organizations
      </a>
      <a routerLink="/platform/bug-reports" routerLinkActive="active">
        <mat-icon aria-hidden="true">bug_report</mat-icon>
        Bug Reports
      </a>
    </nav>

    <button type="button" mat-stroked-button color="primary" (click)="logout()">
      <mat-icon aria-hidden="true">logout</mat-icon>
      Logout
    </button>
  </aside>

  <main class="platform-content">
    <router-outlet></router-outlet>
  </main>
</section>
